import { SearchConditionState } from "./types";
import { Module } from "vuex";
import { RootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";

export const state: SearchConditionState = {
  searchCondition: {
    isDone: true,
    insuranceNo: "",
    insuranceName: "",
    userCode: "",
    userKana: "",
    userInsNo: ""
  },
  error: false
};

const namespaced = true;

export const searchCondition: Module<SearchConditionState, RootState> = {
  namespaced,
  state,
  actions,
  mutations
};
